import Rest from '@/services/Rest'

export default class RegionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/regions'

}
